import { Skeleton } from '@mui/material';

export const UpdateCustomerSettingsSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      sx={{ borderRadius: '10px', height: '700px', marginTop: '8px', position: 'relative' }}
    />
  );
};
